import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';

import './styles/theme.css';
import './styles/header.css';
import './styles/footer.css';
import './styles/carousel.css';
import './styles/introduction.css';
import './styles/collection.css';
import './styles/product.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import AgeVerificationModal from './components/AgeVerificationModal';
import Nav from './components/sections/Nav';
import SidePanel from './components/SidePanel';
import Carousel from './components/carousel/Carousel';
import Footer from './components/sections/Footer';
import Introduction from './components/sections/Introduction';
import CollectionPage from './components/pages/CollectionPage';
import ProductPage from "./components/pages/ProductPage";

function Home({ onOpenAuth }) {
  return (
    <>
      <Carousel onOpenAuth={onOpenAuth} />
      <Introduction/>
      <Footer/>
    </>
  );
}

function Shell() {
  const { loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  // Password reset email links land here as /?reset_uid=...&reset_token=...
  const [resetLink] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const uid = params.get('reset_uid');
    const token = params.get('reset_token');
    return uid && token ? { uid, token } : null;
  });
  const [panelView, setPanelView] = useState(resetLink ? 'set-password' : null);
  const [ageVerified, setAgeVerified] = useState(
    () => sessionStorage.getItem('ageVerified') === 'true'
  );

  // Drop the token from the address bar once we've read it.
  useEffect(() => {
    if (resetLink) navigate(window.location.pathname, { replace: true });
  }, [resetLink, navigate]);

  if (loading) {
    return null; // brief initial session check; avoids an auth-state flash
  }

  const handleAgeVerified = () => {
    sessionStorage.setItem('ageVerified', 'true');
    setAgeVerified(true);
  };

  return (
    <>
      {!isAuthenticated && !ageVerified && (
        <AgeVerificationModal onVerified={handleAgeVerified} />
      )}
      <Nav onOpenAuth={setPanelView} />

      <Routes>
        <Route path="/" element={<Home onOpenAuth={setPanelView} />} />
        <Route path="/collections/:handle" element={<CollectionPage />} />
        <Route path="/products/:id" element={<ProductPage />} />
      </Routes>

      <SidePanel view={panelView} onView={setPanelView} resetLink={resetLink} />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}
